export enum RootIdType {
  account = 'account',
  aggregate = 'aggregate',
  transaction = 'transaction',
  client = 'client',
  legacyTransaction = 'legacyTransaction',
}

export type RootIdTypeKey = keyof typeof RootIdType
